import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { map, take, share, finalize } from 'rxjs/operators';
import { AuthenticationService } from '../../authentication/authentication.service';
import { IProgram } from '../../../models/IProgram';
import { ICourse } from '../../../models/ICourse';
import { IFlight } from '../../../models/IFlight';
import { IStay } from '../../../models/IStay';
import { get } from 'aws-amplify/api';

@Injectable({
    providedIn: 'root'
})
export class ItineraryService {
  stayData: any;
  cacheProgramObservable: Observable<IProgram[]> | null = null;
  constructor(private http: HttpClient, private auth: AuthenticationService) {}
  getPrograms(): Observable<IProgram[]> {
    if (this.cacheProgramObservable) return this.cacheProgramObservable;
    const op = get({
      apiName: 'portal',
      path: 'persons/programs',
    });
    this.cacheProgramObservable = from(
      op.response.then(async (r) => (await r.body.json()) as unknown as IProgram[])
    ).pipe(
      map((data) => data as IProgram[]),
      take(1),
      share(),
      finalize(() => (this.cacheProgramObservable = null))
    );
    return this.cacheProgramObservable;
  }
  getProgramCourses(programId: any): Observable<ICourse[]> {
    const op = get({
      apiName: 'portal',
      path: `persons/programs/${programId}/courses`,
    });
    return from(op.response.then(async (r) => (await r.body.json()) as unknown as ICourse[])).pipe(
      map((data) => data as ICourse[])
    );
  }
  getFlight(programId: any): Observable<IFlight[]> {
    const op = get({
      apiName: 'portal',
      path: `persons/programs/${programId}/travels`,
    });
    return from(
      op.response.then(async (r) => (await r.body.json()) as unknown as IFlight[])
    ).pipe(map((data) => data as IFlight[]));
  }
  getStay(programId: any): Observable<IStay | any> {
    const op = get({
      apiName: 'portal',
      path: `persons/programs/${programId}/stays`,
    });
    return from(op.response.then(async (r) => (await r.body.json()) as any)).pipe(
      map((data) => {
        if (data !== undefined) {
          this.stayData = data;
          if (Array.isArray(data) && data.length === 1) {
            const sorted = [...data].sort(
              (a, b) => new Date(a.checkInDate).getTime() - new Date(b.checkInDate).getTime()
            );
            return sorted[0];
          }
        }
        return data;
      })
    );
  }
}